import { useQuery } from "@tanstack/react-query";
import { UserX } from "lucide-react";

import { endpoints } from "@/api/client";
import { useAuth } from "@/lib/AuthProvider";
import { getAziendaId } from "@/lib/azienda";
import { Button } from "@/components/ui/button";

export function ImpersonationBanner() {
  const auth = useAuth();
  const aziendaId = getAziendaId();
  const statusQ = useQuery({
    queryKey: ["billing-status"],
    queryFn: endpoints.billing.status,
    staleTime: 10_000,
    enabled: auth.impersonating && Boolean(aziendaId),
  });
  if (!auth.impersonating) return null;

  const azienda = aziendaId ? statusQ.data?.azienda : null;

  const stop = async () => {
    const hadAzienda = Boolean(aziendaId);
    await auth.stopImpersonate();
    // Con un'azienda gestita attiva le cache sono nel contesto dell'azienda: ripartiamo puliti.
    if (hadAzienda) window.location.assign("/admin");
  };

  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-500/40 bg-amber-500/15 px-4 py-2 text-sm">
      <span>
        Stai operando come <strong>{auth.email}</strong>
        {azienda && (
          <>
            {" "}
            · azienda <strong>{azienda.ragione_sociale}</strong>
          </>
        )}
        {auth.realEmail !== auth.email && (
          <span className="text-muted-foreground"> (admin: {auth.realEmail})</span>
        )}
      </span>
      <Button size="sm" variant="outline" onClick={() => void stop()}>
        <UserX className="mr-1 h-4 w-4" />
        Termina impersonificazione
      </Button>
    </div>
  );
}
